import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '~/shadcn/ui/table'
import { cn } from '~/shadcn/lib/utils'
import { NoRecords } from '~/@mid_ui/no-records/NoRecords'
import { DateTimeFormatter } from '~/@mid_ui/datetime-formatter/DateTimeFormatter'
import { CurrencyFormatter } from '~/@mid_ui/currency-formatter/CurrencyFormatter'
import type { IAffiliateItem } from '~/@api/generated-api-types-user/Api'

type Props = {
  items: Array<IAffiliateItem>
}

export function AffiliateTable({ items }: Props) {
  if (!items.length) {
    return <NoRecords className="mt-0" />
  }

  return (
    <Table>
      <TableHeader>
        <TableRow className="py-3 text-sm leading-[21px] uppercase [&_th]:border-b [&_th]:border-border">
          <TableHead className="font-normal p-4!">Vytvorené</TableHead>
          <TableHead className="font-normal p-4!">Investor</TableHead>
          <TableHead className="font-normal p-4!">Suma</TableHead>
          <TableHead className="font-normal p-4!">Aktivita</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody className="h-20">
        {items.map((row) => (
          <TableRow
            key={row._id}
            className={cn(
              'py-3 px-2 text-sm/normal! font-semibold leading-[26px]',
              '[&_td]:border-b [&_td]:border-border/20',
              'last:[&_td]:border-b-0'
            )}>
            <TableCell className="p-4!">
              <span className="text-wrap">
                <DateTimeFormatter value={row.createdAt} />
              </span>
            </TableCell>

            <TableCell className="w-full max-w-50 p-4!">
              <span className="text-wrap">{row.userName}</span>
            </TableCell>

            <TableCell className="p-4!">
              <CurrencyFormatter
                value={+row.bonusAffiliate}
                className="text-base"
              />
            </TableCell>

            <TableCell className="p-4!">
              {row.userActive ? 'Aktívny' : 'Neaktívny'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
